import ApiClient from '@/helpers/ApiClient';

class WorkflowApi extends ApiClient {
  public constructor() {
    super('flow');
  }

  public async getNotSupportedSpecialNodes(workspaceId: string | number) {
    return this.get({}, `workflows/not-supported-special-nodes/${workspaceId}`);
  }
}
export default new WorkflowApi();
